
import {mask} from "vue-the-mask";
import { Component, Mixins, Prop } from 'vue-property-decorator';
import SimpleInputMixin from "@/mixins/SimpleInputMixin.vue";

@Component({
  directives: {
    mask
  },
})
export default class IbanNumarasi extends Mixins(SimpleInputMixin) {
  @Prop({ default: 'IBAN' }) label!: string;

  ibanDisplay: string = '';

  mask: string = 'AA## #### #### #### #### #### ##';

  mounted() {
    this.ibanDisplay = this.formatIban(String(this.value || this.localValue || ''));
  }

  onValueChange() {
    this.ibanDisplay = this.formatIban(String(this.value || this.localValue || ''));
  }

  onBlur() {
    this.localValue = this.normalize(String(this.ibanDisplay || ''));
    this.input();
  }

  get rules() {
    return [
      (v: string) => !!v || 'IBAN zorunludur',
      (v: string) => this.isFormatValid(v) || 'IBAN formatı geçersiz',
      (v: string) => this.validateIban(this.normalize(v)) || 'Geçersiz IBAN'
    ];
  }

  // --------------------
  // Helpers
  // --------------------

  normalize(value: string): string {
    return value.replace(/\s+/g, '').toUpperCase();
  }

  formatIban(value: string): string {
    return this.normalize(value).replace(/(.{4})/g, '$1 ').trim();
  }

  isFormatValid(value: string): boolean {
    return /^TR\d{2}(?:\s?\d{4}){5}\s?\d{2}$/.test(value);
  }

  validateIban(iban: string): boolean {
    if (!/^TR\d{24}$/.test(iban)) return false;

    const rearranged = iban.slice(4) + iban.slice(0, 4);
    const numeric = rearranged.replace(/[A-Z]/g, c =>
        (c.charCodeAt(0) - 55).toString()
    );

    let remainder = numeric;
    while (remainder.length > 2) {
      const block = remainder.slice(0, 9);
      remainder =
          (parseInt(block, 10) % 97).toString() + remainder.slice(block.length);
    }

    return parseInt(remainder, 10) % 97 === 1;
  }
}
